import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GlobalMessageService } from '@spartacus/core';
import {
  PageLayoutService,
  ProductListComponent,
  ProductListComponentService,
  ViewConfig,
} from '@spartacus/storefront';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-documents-tab',
  templateUrl: './documents-tab.component.html',
  styleUrls: ['./documents-tab.component.scss'],
  encapsulation: ViewEncapsulation?.None,
  standalone: false
})
export class DocumentsTabComponent extends ProductListComponent {
  @Input() product;

  isMobile: boolean;
  showSearch: boolean = false;
  inputFormControl = new FormControl('');
  sortControl = new FormControl('code_asc');
  filteredProduct: any;
  initialKbEcomDocuments: any;
  productCopy: any;
  currentArray: any;
  private destroy$ = new Subject<void>();
  constructor(
    public breakpointObserver: BreakpointObserver,
    productListComponentService: ProductListComponentService,
    pageLayoutService: PageLayoutService,
    globalMessageService: GlobalMessageService,
    scrollConfig: ViewConfig,
    private formBuilder: FormBuilder
  ) {
    super(
      pageLayoutService,
      productListComponentService,
      globalMessageService,
      scrollConfig
    );
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.setViewMode(this.ViewModes.Grid);
        } else {
          this.setViewMode(this.ViewModes.List);
        }
      });
  }

  InputValueChanged(el, currentArray) {
    const newValue = (el.target as HTMLSelectElement).value;
    this.search(newValue, currentArray);
  }
  sortControlValueChanged(el, currentArray) {
    const newValue = (el.target as HTMLSelectElement).value;
    this.sortBy(newValue, currentArray);
  }

  sortBy(option: string, currentArray) {
    const key = currentArray;
    const sortedArray = currentArray.slice();
    const [property, order] = option.split('_');
    this.productCopy = sortedArray.sort((a, b) => {
      const aValue = property === 'releaseDate' ? this.parseDate(a[property]) : a[property];
      const bValue = property === 'releaseDate' ? this.parseDate(b[property]) : b[property];

      if (aValue < bValue) {
        return order === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }
  parseDate(dateString: string): Date | null {
    const formats = [
      'DD-MM-YYYY',
      'MM-DD-YYYY',
      'YYYY-MM-DD',
      'DD/MM/YYYY',
      'MM/DD/YYYY',
      'YYYY/MM/DD',
      'DD.MM.YYYY',
      'MM.DD.YYYY',
      'YYYY.MM.DD',
    ];
    const momentDate = moment(dateString, formats, true);
    return momentDate.isValid() ? momentDate.toDate() : null;
  }

  search(value: string,  ArrayName: string) {
     this.currentArray = this.product.kbEcomDocuments;
    if (value.trim() === '') {
      this.productCopy = this.currentArray;
    } else {
        // Perform filtering based on search term
        this.productCopy= this.currentArray.filter(
            (item) => {
                return Object.values(item).some((val: any) =>
                    val.toString().toLowerCase().includes(value.toLowerCase())
                );
            }
        );
    }
  }
  ngOnChanges() {
    this.productCopy = JSON.parse(JSON.stringify(this.product.kbEcomDocuments));
  }
  override ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.destroy$.next();
    this.destroy$.complete();

  }

}
